import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null,
    location: null,
    error: null,
    size: -1,
    loading: false
  },
  mutations: {
    setUser: (state, payload) =>{
      state.user = payload
    },
    setSize: (state, payload) =>{
      state.size = payload
    },
    setLocation: (state, payload) =>{
        state.location = payload
      },
  },
  actions: {

  }
})
